<template>
	<div class="nav-menu">
		<div class="logo" @click="handleLogoClick">
			<img src="@/assets/images/logo.png" />
		</div>

		<!-- 桌面端导航 -->
		<nav class="main-nav desktop-nav">
			<ul class="nav-list">
				<li v-for="item in desktopMenuItems" :key="item.path" class="nav-item" :class="{ 
                            'parent-active': item.isParentActive,
                            'has-submenu': item.children,
                            'direct-active': item.isActive
                        }" @mouseenter="handleMouseEnter(item)" @mouseleave="handleMouseLeave">
					<a v-if="!item.children && item.path === '/'" href="javascript:void(0)" class="nav-link" :class="{ 
                                'router-link-active': item.isActive
                            }" @click="handleHomeClick">
						<span>{{ item.name }}</span>
					</a>

					<router-link v-else-if="!item.children" :to="item.path" exact class="nav-link"
						@click="closeAllSubmenus">
						<span>{{ item.name }}</span>
					</router-link>

					<a v-else href="javascript:void(0)" class="nav-link dropdown-toggle" :class="{ 
                                'parent-active': item.isParentActive,
                                'router-link-active': item.isParentActive
                            }" @click="toggleSubmenu(item.path)">
						<span>{{ item.name }}</span>
					</a>

					<!-- 二级菜单 -->
					<transition name="submenu">
						<ul v-if="item.children && openSubmenu === item.path" class="submenu"
							@mouseenter="handleSubmenuEnter" @mouseleave="handleSubmenuLeave">
							<li v-for="child in item.children" :key="child.path" class="submenu-item"
								:class="{ 'active': child.isActive }">
								<router-link :to="child.path" class="submenu-link" @click="closeAllSubmenus">
									<span>{{ child.name }}</span>
								</router-link>
							</li>
						</ul>
					</transition>
				</li>
			</ul>
		</nav>

		<!-- 移动端菜单 -->
		<div class="mobile-menu-wrapper">
			<!-- 移动端菜单按钮 -->
			<button class="mobile-menu-toggle" @click="toggleMobileMenu" :class="{ 'active': isMobileMenuOpen }">
				<span class="hamburger-line"></span>
				<span class="hamburger-line"></span>
				<span class="hamburger-line"></span>
			</button>

			<!-- 遮罩层 -->
			<transition name="overlay">
				<div v-if="isMobileMenuOpen" class="mobile-menu-overlay" @click="closeMobileMenu"></div>
			</transition>

			<!-- 移动端菜单内容 -->
			<transition name="mobile-menu">
				<div v-if="isMobileMenuOpen" class="mobile-menu-content">
					<div class="mobile-menu-header">
						<div class="mobile-logo" @click="handleMobileLogoClick">
							<img src="@/assets/images/logo.png" alt="Logo" />
						</div>
						<button class="mobile-menu-close" @click="closeMobileMenu">
							<span>×</span>
						</button>
					</div>

					<nav class="mobile-nav">
						<ul class="mobile-nav-list">
							<li v-for="item in activeMenuStates" :key="item.path" class="mobile-nav-item" :class="{ 
                                        'has-submenu': item.children,
                                        'parent-active': item.isParentActive,
                                        'direct-active': item.isActive,
                                        'is-home': item.path === '/',
                                        'home-active': item.path === '/' && item.isActive,
                                        'home-inactive': item.path === '/' && !item.isActive
                                    }">
								<!-- 一级菜单 -->
								<div class="mobile-nav-link-wrapper">
									<a v-if="!item.children && item.path === '/'" href="javascript:void(0)"
										class="mobile-nav-link" :class="{ 
                                                'router-link-active': item.isActive
                                            }" @click="handleMobileHomeClick">
										<span class="mobile-nav-icon" :class="item.icon"></span>
										<span class="mobile-nav-text">{{ item.name }}</span>
									</a>

									<router-link v-else-if="!item.children" :to="item.path" exact
										class="mobile-nav-link" @click="closeMobileMenu">
										<span class="mobile-nav-icon" :class="item.icon"></span>
										<span class="mobile-nav-text">{{ item.name }}</span>
									</router-link>

									<a v-else href="javascript:void(0)" class="mobile-nav-link"
										:class="{ 'parent-active': item.isParentActive }"
										@click="toggleMobileSubmenu(item.path)">
										<span class="mobile-nav-icon" :class="item.icon"></span>
										<span class="mobile-nav-text">{{ item.name }}</span>
										<span class="mobile-arrow-icon"
											:class="{ 'rotated': openMobileSubmenu === item.path }">
											▼
										</span>
									</a>
								</div>

								<!-- 二级菜单 -->
								<transition name="mobile-submenu">
									<ul v-if="item.children && openMobileSubmenu === item.path" class="mobile-submenu">
										<li v-for="child in item.children" :key="child.path" class="mobile-submenu-item"
											:class="{ 'active': child.isActive }">
											<router-link :to="child.path" exact class="mobile-submenu-link"
												@click="closeMobileMenu">
												<span class="mobile-submenu-icon" :class="child.icon"></span>
												<span class="mobile-submenu-text">{{ child.name }}</span>
											</router-link>
										</li>
									</ul>
								</transition>
							</li>
						</ul>
					</nav>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'NavMenu',
		data() {
			return {
				openSubmenu: null,
				isMobileMenuOpen: false,
				openMobileSubmenu: null,
				// 添加防重复点击标志
				isNavigating: false,
				menuItems: [{
						path: '/',
						name: '首页',
						icon: 'icon-home'
					},
					{
						path: '/products',
						name: '产品与服务',
						icon: 'icon-product',
						children: [{
								path: '/products/sbfw',
								name: '知识产权服务',
								icon: 'icon-trademark'
							},
							{
								path: '/products/zlfw',
								name: '科创及法律服务',
								icon: 'icon-patent'
							},
							{
								path: '/products/flfw',
								name: '技术转移转化服务',
								icon: 'icon-law'
							},
							{
								path: '/products/xmsb',
								name: '产业园区投资及运营服务',
								icon: 'icon-project'
							},
							{
								path: '/products/zhyy',
								name: '智慧园区建设服务',
								icon: 'icon-smart-park'
							},
							{
								path: '/products/3dprint',
								name: '3D打印机及产品生产销售',
								icon: 'icon-printer'
							},
							{
								path: '/products/ai',
								name: 'AI智能系统',
								icon: 'icon-ai'
							}
						]
					},
					{
						path: '/aboutUs/gsjj',
						name: '关于万硕',
						icon: 'icon-about',
				},
					{
						path: '/news',
						name: '新闻资讯',
						icon: 'icon-news',
						children: [{
							path: '/news/newsList',
							name: '公司新闻',
							icon: 'icon-company-news'
						}, {
							path: '/news/newsList?index=1',
							name: '最新政策',
							icon: 'icon-policy'
						}]
					},
					{
						path: '/caseCenter/khal',
						name: '案例中心',
						icon: 'icon-case',
					},
					{
						path: '/video',
						name: '视频展示',
						icon: 'icon-video',
					},
					{
						path: '/partyBuilding/djzl',
						name: '党建专栏',
						icon: 'icon-party',
					},
					{
						path: '/recruitment',
						name: '招聘信息',
						icon: 'icon-recruitment',
					},
					{
						path: '/AboutView',
						name: '联系我们',
						icon: 'icon-contact'
					},
				]
			}
		},
		computed: {
			// 使用computed确保响应式更新
			activeMenuStates() {
				const currentPath = this.$route.path;
				const currentQuery = this.$route.query;
				// console.log('🔄 计算属性执行 - 当前路由:', currentPath);

				return this.menuItems.map(item => {
					let isParentActive = false;
					let isDirectActive = false;

					if (item.children) {
						// 检查是否有任何子菜单项与当前路由匹配（包括查询参数）
						isParentActive = item.children.some(child => {
							// 解析子菜单项的路径和查询参数
							const childPathParts = child.path.split('?');
							const childPath = childPathParts[0];
							const childQuery = childPathParts[1] ? this.parseQuery(childPathParts[1]) : {};
							
							// 检查路径是否匹配
							if (currentPath !== childPath) {
								return false;
							}
							
							// 如果子菜单项有查询参数，检查查询参数是否匹配
							if (Object.keys(childQuery).length > 0) {
								return Object.keys(childQuery).every(key => 
									currentQuery[key] === childQuery[key]
								);
							}
							
							return true;
						});
						
						// 检查父级菜单是否直接匹配当前路径
						isDirectActive = currentPath === item.path;
					} else {
						// 对于首页，只有当路径完全等于 '/' 时才激活
						if (item.path === '/') {
							isDirectActive = currentPath === '/';
						} else {
							isDirectActive = currentPath === item.path;
						}
					}

					return {
						...item,
						isActive: isDirectActive,
						isParentActive: isParentActive || isDirectActive, // 父级激活应包含直接激活的情况
						children: item.children ? item.children.map(child => {
							// 解析子菜单项的路径和查询参数
							const childPathParts = child.path.split('?');
							const childPath = childPathParts[0];
							const childQuery = childPathParts[1] ? this.parseQuery(childPathParts[1]) : {};
							
							// 检查路径是否匹配
							if (currentPath !== childPath) {
								return {
									...child,
									isActive: false
								};
							}
							
							// 如果子菜单项有查询参数，检查查询参数是否匹配
							if (Object.keys(childQuery).length > 0) {
								const isActive = Object.keys(childQuery).every(key => 
									currentQuery[key] === childQuery[key]
								);
								return {
									...child,
									isActive: isActive
								};
							}
							
							// 如果没有查询参数，但当前路由有查询参数，则不激活
							if (Object.keys(currentQuery).length > 0) {
								return {
									...child,
									isActive: false
								};
							}
							
							return {
								...child,
								isActive: true
							};
						}) : null
					};
				});
			},

			// 专门为桌面端导航提供的计算属性
			desktopMenuItems() {
				return this.activeMenuStates;
			}
		},

		methods: {
			// 解析查询参数字符串
			parseQuery(queryString) {
				const query = {};
				if (queryString) {
					queryString.split('&').forEach(pair => {
						const [key, value] = pair.split('=');
						query[decodeURIComponent(key)] = decodeURIComponent(value || '');
					});
				}
				return query;
			},
			
			// 桌面端首页点击处理
			handleHomeClick() {
				// 添加防重复点击检查
				if (this.isNavigating) return;
				
				// 设置导航标志
				this.isNavigating = true;
				
				// 避免重复跳转导致NavigationDuplicated错误
				if (this.$route.path !== '/') {
					this.$router.push('/').catch(err => {
						// 忽略NavigationDuplicated错误
						if (err.name !== 'NavigationDuplicated') {
							console.error('路由跳转错误:', err);
						}
					});
				}
				this.closeAllSubmenus();
				
				// 延迟重置导航标志
				setTimeout(() => {
					this.isNavigating = false;
				}, 100);
			},

			// Logo点击处理方法
			handleLogoClick() {
				// 添加防重复点击检查
				if (this.isNavigating) return;
				
				// 设置导航标志
				this.isNavigating = true;
				
				// 避免重复跳转导致NavigationDuplicated错误
				if (this.$route.path !== '/') {
					this.$router.push('/').catch(err => {
						// 忽略NavigationDuplicated错误
						if (err.name !== 'NavigationDuplicated') {
							console.error('路由跳转错误:', err);
						}
					});
				}
				
				// 延迟重置导航标志
				setTimeout(() => {
					this.isNavigating = false;
				}, 100);
			},

			// 移动端首页点击处理
			handleMobileHomeClick() {
				// 添加防重复点击检查
				if (this.isNavigating) return;
				
				// 设置导航标志
				this.isNavigating = true;
				
				// 避免重复跳转导致NavigationDuplicated错误
				if (this.$route.path !== '/') {
					this.$router.push('/').catch(err => {
						// 忽略NavigationDuplicated错误
						if (err.name !== 'NavigationDuplicated') {
							console.error('路由跳转错误:', err);
						}
					});
				}
				this.closeMobileMenu();
				
				// 延迟重置导航标志
				setTimeout(() => {
					this.isNavigating = false;
				}, 100);
			},

			// 移动端Logo点击处理方法
			handleMobileLogoClick() {
				// 添加防重复点击检查
				if (this.isNavigating) return;
				
				// 设置导航标志
				this.isNavigating = true;
				
				// 避免重复跳转导致NavigationDuplicated错误
				if (this.$route.path !== '/') {
					this.$router.push('/').catch(err => {
						// 忽略NavigationDuplicated错误
						if (err.name !== 'NavigationDuplicated') {
							console.error('路由跳转错误:', err);
						}
					});
				}
				// 关闭移动端菜单
				this.closeMobileMenu();
				
				// 延迟重置导航标志
				setTimeout(() => {
					this.isNavigating = false;
				}, 100);
			},

			// 桌面端菜单方法
			closeAllSubmenus() {
				this.openSubmenu = null
				this.clearLeaveTimer()
			},

			handleMouseEnter(item) {
				this.clearLeaveTimer()
				if (item.children) {
					this.openSubmenu = item.path
				}
			},

			handleMouseLeave() {
				this.leaveTimer = setTimeout(() => {
					this.openSubmenu = null
				}, 150)
			},

			handleSubmenuEnter() {
				this.clearLeaveTimer()
			},

			handleSubmenuLeave() {
				this.leaveTimer = setTimeout(() => {
					this.openSubmenu = null
				}, 150)
			},

			clearLeaveTimer() {
				if (this.leaveTimer) {
					clearTimeout(this.leaveTimer)
					this.leaveTimer = null
				}
			},

			toggleSubmenu(path) {
				this.openSubmenu = this.openSubmenu === path ? null : path
			},

			// 移动端菜单方法
			toggleMobileMenu() {
				this.isMobileMenuOpen = !this.isMobileMenuOpen;
				this.openMobileSubmenu = null;

				// 控制body滚动
				if (this.isMobileMenuOpen) {
					document.body.style.overflow = 'hidden';
				} else {
					document.body.style.overflow = '';
				}
			},

			closeMobileMenu() {
				this.isMobileMenuOpen = false;
				this.openMobileSubmenu = null;
				document.body.style.overflow = '';
			},

			toggleMobileSubmenu(path) {
				this.openMobileSubmenu = this.openMobileSubmenu === path ? null : path;
			},

			// 通用方法
			isActive(path) {
				return this.$route.path === path || this.$route.path.startsWith(path + '/')
			},

			// 处理二级菜单点击
			handleSubMenuClick(path) {
				// console.log('🔗 二级菜单点击:', {
				//     目标路径: path,
				//     当前路径: this.$route.path,
				//     时间戳: new Date().toLocaleTimeString()
				// });
				this.closeMobileMenu();
			},

			// 手动更新移动端首页状态
			updateMobileHomeState() {
				this.$nextTick(() => {
					const homeLinks = this.$el.querySelectorAll('.mobile-nav-link.home-nav-link');
					homeLinks.forEach(link => {
						// 强制移除所有router-link相关类
						link.classList.remove('router-link-active', 'router-link-exact-active');

						// 根据当前路由决定是否添加激活类
						if (this.$route.path === '/') {
							link.classList.add('router-link-active');
						}

						console.log('🔧 手动更新首页状态:', {
							当前路由: this.$route.path,
							首页应该激活: this.$route.path === '/',
							链接类列表: Array.from(link.classList)
						});
					});
				});
			},

			// 处理桌面端二级菜单点击
			handleDesktopSubMenuClick(childName, childPath) {
				// console.log('%c🖥️ 桌面端二级菜单点击', 'background: red; color: white; padding: 3px;', {
				//     菜单名: childName,
				//     目标路径: childPath,
				//     当前路径: this.$route.path,
				//     时间戳: new Date().toLocaleTimeString()
				// });

				// 关闭子菜单
				this.closeAllSubmenus();
			},

			// 处理移动端二级菜单点击
			handleMobileSubMenuClick(childName, childPath) {
				// console.log('%c📱 移动端二级菜单点击', 'background: purple; color: white; padding: 3px;', {
				//     菜单名: childName,
				//     目标路径: childPath,
				//     当前路径: this.$route.path,
				//     时间戳: new Date().toLocaleTimeString()
				// });

				// 关闭移动端菜单
				this.closeMobileMenu();
			},

			// 处理普通菜单点击（用于调试）
			handleMenuClick(itemName, itemPath) {
				// console.log('%c🎯 普通菜单点击', 'background: green; color: white; padding: 3px;', {
				//     菜单名: itemName,
				//     目标路径: itemPath,
				//     当前路径: this.$route.path,
				//     时间戳: new Date().toLocaleTimeString()
				// });
			}
		},

		watch: {
			'$route': {
				handler(to, from) {
					if (this.isMobileMenuOpen && from && from.path !== to.path) {
						this.closeMobileMenu();
					}
					// 只在路由实际变化时才更新，避免不必要的强制更新
					if (from && to.path !== from.path) {
						this.$forceUpdate();
					}
				},
				immediate: true
			}
		},

		mounted() {
			document.addEventListener('click', (e) => {
				if (!this.$el.contains(e.target)) {
					this.closeAllSubmenus()
				}
			});
		},

		beforeDestroy() {
			this.clearLeaveTimer()
			document.body.style.overflow = '';
		}
	}
</script>

<style lang="scss" scoped>
	$primary-color: #667eea;
	$secondary-color: #764ba2;

	.logo {
		cursor: pointer;
	}

	.nav-menu {
		display: flex;
		// background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		// box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		position: absolute;
		z-index: 1000;
		justify-content: space-between;
		width: 100%;
		box-sizing: border-box;
		padding: 0 40px 0 150px;
		margin-top: 10px;
		align-items: center;
		background: transparent; // 改为透明背景，避免遮挡logo

		.logo {
			img {
				max-height: 85px;
			}
		}

		.main-nav {
			// flex: 1;
			font-size: 1.125rem;
		}
	}

	// 桌面端导航样式
	.desktop-nav {
		.nav-list {
			display: flex;
			list-style: none;
			margin: 0;
			padding: 0;
			align-items: center;
		}

		.nav-item {
			position: relative;

			a {
				padding-top: 30px;
			}

			&:hover {
				// background: rgba(255, 255, 255, 0.1);
			}

			&.active {
				background: rgba(255, 255, 255, 0.2);
			}

			&.has-submenu {
				.nav-link {
					padding-right: 35px;
				}
			}
		}

		.nav-link {
			display: flex;
			align-items: center;
			padding: 15px 20px;
			color: #fff;
			text-decoration: none;
			font-weight: 500;
			transition: all 0.3s ease;
			position: relative;

			&:before {
				content: "";
				position: absolute;
				width: 0;
				height: 2px;
				background-color: #fff;
				left: 50%;
				transform: translateX(-50%);
				top: 0;
				transition: all 0.3s ease;
			}

			&:hover:before {
				// color: #f0f0f0;
				// transform: translateY(-1px);
				width: 100%;
			}

			&.router-link-active:before {
				color: #fff !important;
				width: 100%;
				// background: rgba(255, 255, 255, 0.2) !important;
				// font-weight: 600 !important;
			}
		}

		.nav-icon {
			margin-right: 8px;
			font-size: 16px;
			width: 20px;
			text-align: center;
		}

		.arrow-icon {
			position: absolute;
			right: 10px;
			font-size: 12px;
			transition: transform 0.3s ease;

			&.rotated {
				transform: rotate(180deg);
			}
		}

		.submenu {
			position: absolute;
			top: 100%;
			left: 0;
			background: #fff;
			border-radius: 8px;
			box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
			list-style: none;
			padding: 10px 0;
			margin: 0;
			min-width: 250px;
			z-index: 1001;
			white-space: nowrap;

			&::before {
				content: '';
				position: absolute;
				top: -8px;
				left: 20px;
				border-left: 8px solid transparent;
				border-right: 8px solid transparent;
				border-bottom: 8px solid #fff;
			}
		}

		.submenu-item {
			&:hover {
				background: #f8f9fa;
			}

			&.active {
				background: #e3f2fd;

				.submenu-link {
					color: $primary-color;
					font-weight: 600;
				}
			}
		}

		.submenu-link {
			display: flex;
			align-items: center;
			padding: 15px 20px !important;
			color: #333 !important;
			text-decoration: none;
			transition: all 0.3s ease;
			font-size: 14px !important;
			line-height: 1.3;

			&:hover {
				color: $primary-color !important;
				padding: 15px 30px 15px 30px !important;
			}
		}

		.submenu-icon {
			margin-right: 10px;
			font-size: 14px;
			color: #666;
			width: 16px;
			text-align: center;
		}
	}

	// 移动端菜单样式
	.mobile-menu-wrapper {
		position: relative;
		z-index: 9999;
	}

	// 汉堡菜单按钮
	.mobile-menu-toggle {
		display: none;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 40px;
		height: 40px;
		background: transparent;
		border: none;
		cursor: pointer;
		padding: 8px;
		border-radius: 4px;
		transition: all 0.3s ease;

		&:hover {
			background: rgba(255, 255, 255, 0.1);
		}

		.hamburger-line {
			width: 24px;
			height: 3px;
			background: #fff;
			margin: 2px 0;
			transition: all 0.3s ease;
			border-radius: 2px;
		}

		&.active {
			.hamburger-line {
				&:nth-child(1) {
					transform: rotate(45deg) translate(6px, 6px);
				}

				&:nth-child(2) {
					opacity: 0;
				}

				&:nth-child(3) {
					transform: rotate(-45deg) translate(6px, -6px);
				}
			}
		}
	}

	// 遮罩层
	.mobile-menu-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		z-index: 9998;
	}

	// 移动端菜单内容
	.mobile-menu-content {
		position: fixed;
		top: 0;
		right: 0;
		width: 80%;
		max-width: 320px;
		height: 100%;
		background: #fff;
		z-index: 9999;
		overflow-y: auto;
		box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
	}

	// 移动端菜单头部
	.mobile-menu-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20px;
		background: rgba(102, 126, 234, 0.8); // 使用半透明背景，减少对logo的遮挡
		color: #fff;

		.mobile-logo {
			img {
				max-height: 36px;
			}
		}

		.mobile-menu-close {
			background: transparent;
			border: none;
			color: #fff;
			font-size: 28px;
			cursor: pointer;
			padding: 0;
			width: 32px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50%;
			transition: all 0.3s ease;
			opacity: 0;
			animation: fadeIn 0.5s ease 0.4s forwards;

			&:hover {
				background: rgba(255, 255, 255, 0.2);
				transform: rotate(90deg);
			}
		}
	}

	// 头部滑入动画
	@keyframes slideInDown {
		from {
			opacity: 0;
			transform: translateY(-20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	// 淡入动画
	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	// 移动端导航
	.mobile-nav {
		padding: 0;
	}

	.mobile-nav-list {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.mobile-nav-item {
		border-bottom: 1px solid #f0f0f0;

		&:last-child {
			border-bottom: none;
		}

		&.parent-active,
		&.direct-active {
			.mobile-nav-link {
				background: #e3f2fd !important;
				color: $primary-color !important;
				font-weight: 600 !important;
			}
		}
	}

	.mobile-nav-link-wrapper {
		position: relative;
	}

	.mobile-nav-link {
		display: flex;
		align-items: center;
		padding: 16px 20px;
		color: #333;
		text-decoration: none;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		position: relative;
		border-left: 3px solid transparent;

		&:hover {
			background: #f8f9fa;
			color: $primary-color;
			border-left-color: rgba(102, 126, 234, 0.3);
			transform: translateX(5px);
		}

		&.router-link-active {
			background: #e3f2fd;
			color: $primary-color;
			font-weight: 600;
			border-left-color: $primary-color;
		}

		&:active {
			transform: scale(0.98);
		}
	}

	.mobile-nav-icon {
		margin-right: 12px;
		font-size: 16px;
		width: 20px;
		text-align: center;
	}

	.mobile-nav-text {
		flex: 1;
		font-size: 16px;
	}

	.mobile-arrow-icon {
		font-size: 12px;
		color: #666;
		transition: transform 0.3s ease;

		&.rotated {
			transform: rotate(180deg);
		}
	}

	// 移动端二级菜单
	.mobile-submenu {
		list-style: none;
		margin: 0;
		padding: 0;
		background: #f8f9fa;
	}

	.mobile-submenu-item {
		&.active {
			.mobile-submenu-link {
				background: #e3f2fd;
				color: $primary-color;
				font-weight: 600;
			}
		}
	}

	.mobile-submenu-link {
		display: flex;
		align-items: center;
		padding: 14px 20px 14px 52px;
		color: #555;
		text-decoration: none;
		transition: all 0.3s ease;
		border-left: 3px solid transparent;

		&:hover {
			background: #e9ecef;
			color: $primary-color;
			border-left-color: $primary-color;
		}

		&.router-link-active {
			background: #e3f2fd;
			color: $primary-color;
			font-weight: 600;
			border-left-color: $primary-color;
		}
	}

	.mobile-submenu-icon {
		margin-right: 10px;
		font-size: 14px;
		width: 16px;
		text-align: center;
	}

	.mobile-submenu-text {
		font-size: 14px;
	}

	// 动画效果
	.submenu-enter-active,
	.submenu-leave-active {
		transition: all 0.3s ease;
		transform-origin: top;
	}

	.submenu-enter-from,
	.submenu-leave-to {
		opacity: 0;
		transform: scaleY(0.8) translateY(-10px);
	}

	.overlay-enter-active,
	.overlay-leave-active {
		transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
	}

	.overlay-enter,
	.overlay-leave-to {
		opacity: 0;
	}

	.mobile-menu-enter-active {
		transition: transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
	}

	.mobile-menu-leave-active {
		transition: transform 0.4s cubic-bezier(0.4, 0, 0.6, 1);
	}

	.mobile-menu-enter {
		transform: translateX(100%);
	}

	.mobile-menu-leave-to {
		transform: translateX(100%);
	}

	.mobile-submenu-enter-active,
	.mobile-submenu-leave-active {
		transition: all 0.3s ease;
		overflow: hidden;
	}

	.mobile-submenu-enter-from,
	.mobile-submenu-leave-to {
		max-height: 0;
		opacity: 0;
	}

	.mobile-submenu-enter-to,
	.mobile-submenu-leave-from {
		max-height: 500px;
		opacity: 1;
	}
	
	@media (max-width: 1500px) {
		::v-deep .desktop-nav .nav-item a{
			font-size: 16px !important;
			padding-right: 20px !important;
		}
	}

	// 响应式设计
	@media (max-width: 768px) {
		.desktop-nav {
			display: none;
		}

		.mobile-menu-toggle {
			display: flex;
		}

		.nav-menu {
			justify-content: space-between;
			padding: 0 15px;
		}

		.logo {
			img {
				max-height: 46px !important; 
			}
		}
	}

	@media (min-width: 769px) {
		.mobile-menu-wrapper {
			display: none;
		}
	}

	// 图标样式 (使用CSS类名模拟图标)
	.icon-home::before {
		content: '🏠';
	}

	.icon-product::before {
		content: '📦';
	}

	.icon-trademark::before {
		content: '®️';
	}

	.icon-patent::before {
		content: '📜';
	}

	.icon-law::before {
		content: '⚖️';
	}

	.icon-project::before {
		content: '📋';
	}

	.icon-about::before {
		content: '🏢';
	}

	.icon-news::before {
		content: '📰';
	}

	.icon-company-news::before {
		content: '📢';
	}

	.icon-policy::before {
		content: '📄';
	}

	.icon-case::before {
		content: '💼';
	}

	.icon-video::before {
		content: '🎬';
	}

	.icon-party::before {
		content: '🚩'; /* 党建专栏使用红旗图标 */
	}

	.icon-recruitment::before {
		content: '👤';
	}

	.icon-contact::before {
		content: '📞';
	}

	.icon-user::before {
		content: '👤';
	}

	.icon-order::before {
		content: '📋';
	}

	.icon-settings::before {
		content: '⚙️';
	}

	.icon-info::before {
		content: 'ℹ️';
	}

	.icon-list::before {
		content: '📄';
	}

	.icon-add::before {
		content: '➕';
	}

	.icon-category::before {
		content: '📂';
	}

	.icon-role::before {
		content: '👥';
	}

	.icon-permission::before {
		content: '🔐';
	}

	.icon-pending::before {
		content: '⏳';
	}

	.icon-completed::before {
		content: '✅';
	}

	.icon-general::before {
		content: '🔧';
	}

	.icon-security::before {
		content: '🛡️';
	}
	
	.icon-smart-park::before {
		content: '🏙️'; /* 智慧园区使用城市图标 */
	}
	
	.icon-printer::before {
		content: '🖨️'; /* 3D打印机使用打印机图标 */
	}
	
	.icon-ai::before {
		content: '🤖'; /* AI智能系统使用机器人图标 */
	}
</style>